/* @flow */
import * as React from 'react';
import { IndexRedirect, Route, Redirect } from 'react-router';

import WidgetSettingsView from './components/WidgetSettingsView.jsx';
import LinkedAccountsSettingsView from './components/LinkedAccountsSettingsView.jsx';
import IndividualPlanView from './components/IndividualPlanView.jsx';
import PrintSettingsView from './components/PrintSettingsView.jsx';
import SettingsViewRouteHandler from './routeHandlers/SettingsViewRouteHandler.jsx';
import PrivacySettingsView from './components/PrivacySettingsView.jsx';
import CommunicationSettingsContainer from './containers/CommunicationSettingsContainer.jsx';
import OrganizeClassesView from 'settings/components/OrganizeClassesView.jsx';
import UserProfileView from 'settings/components/UserProfileView';
import AccountSettingsView from 'settings/components/AccountSettingsView.jsx';
import RequireOwnerOnEnter from 'lib/RequireOwnerOnEnter';
import RequireFeatures from 'lib/RequireFeatures';

const requireIndividualPlanFlag = RequireFeatures(
  ['2018.dec.canada_individual_plans'],
  (nextState, replaceWith) => {
    replaceWith('/settings/profile');
  }
);

export default (
  <Route
    path="/settings(/)"
    component={SettingsViewRouteHandler}
    onEnter={SettingsViewRouteHandler.onEnter}>
    <Route path="/settings/communication" component={CommunicationSettingsContainer} />
    <Route path="/settings/widget" component={WidgetSettingsView} onEnter={RequireOwnerOnEnter} />
    <Route path="/settings/export" component={PrintSettingsView} onEnter={RequireOwnerOnEnter} />
    <Route path="/settings/privacy" component={PrivacySettingsView} />
    <Route path="/settings/organize_classes" component={OrganizeClassesView} />
    <Route path="/settings/profile" component={UserProfileView} />
    <Route path="/settings/account" component={AccountSettingsView} />
    <Route path="/settings/connected_accounts" component={LinkedAccountsSettingsView} />
    <Route
      path="/settings/individual_plan"
      component={IndividualPlanView}
      onEnter={requireIndividualPlanFlag}
    />
    <Redirect from="/settings/notifications" to="/settings/communication" />
    <Redirect from="/settings/chat" to="/settings/communication" />
    <Redirect from="/settings/archived" to="/settings/organize_classes" />
    <IndexRedirect to="/settings/profile" />
  </Route>
);
